import { render, staticRenderFns } from "./StarLabel.vue?vue&type=template&id=c357d4e6&scoped=true&"
import script from "./StarLabel.vue?vue&type=script&lang=js&"
export * from "./StarLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c357d4e6",
  null
  
)

export default component.exports